<template>
  <div class="app-download">
    <a href="https://thtopnews.onelink.me/sfeV?pid=news_official&c=news_official" target="_blank" rel="noopener noreferrer"></a>
  </div>
</template>
<script>
export default {
};
</script>
<style lang="stylus" scoped>
  .app-download
    width 112px
    height 162px 
    background-image url(../assets/image/th_new.png), url(../assets/image/bh_as.png), url(../assets/image/bh_gp.png)
    background-size 100%, 76px, 76px
    background-repeat no-repeat
    background-position-x 0, 18px, 18px
    background-position-y 0, 112px, 139px
    position fixed
    right 0
    top 50%
    transform translateY(-50%)
    &>a
      display block
      width 100%
      height 100%
</style>



// WEBPACK FOOTER //
// Download.vue?a4fa6ae0